import {createStore} from 'fluxury'
import {loadPrograms, loadStates, changeSelectedState} from '../actions/actions'

const HardestHitStore = createStore(
  'HardestHitStore',
  {
    programs: [],
    states: [],
    selectedState: ''
  },
  (state, action) => {
    switch(action.type) {
      case loadPrograms:
      return Object.assign( {}, state, { programs: action.data } )
      case loadStates:
      return Object.assign( {}, state, { states: action.data } )
      case changeSelectedState:
      return Object.assign( {}, state, { selectedState: action.data } )
      default:
      return state
    }
  }, {
    getPrograms: (state) => state.programs,
    getStates: (state) => state.states,
    getStateName: (state, stateKey) => {
      var foundState = state.states.filter(
        (n) => n.key === stateKey
      )
      return foundState.length > 0 ? foundState[0].name : ''
    },
    getStateURL: (state, stateKey) => {
      var foundState = state.states.filter(
        (n) => n.key === stateKey
      )
      return foundState.length > 0 ? foundState[0].url : ''
    },
    getSelectedState: (state) => state.selectedState,
    hasProgram: (state, stateKey) => {
      var foundState = state.states.filter(
        (n) => n.key === stateKey
      )
      return foundState.length > 0
    },
    hasActiveProgram: (state, stateKey) => {
      var foundState = state.states.filter(
        (n) => n.key === stateKey
      )
      return foundState.length > 0 ? foundState[0].programs.length > 0 : false
    },
    isProgramActive: (state, stateKey, programKey) => {
      var foundState = state.states.filter(
        (n) => n.key === stateKey
      )
      if (foundState.length === 0) {
        return false;
      }

      return foundState[0].programs.indexOf(+programKey) > -1;
    }
  }
)

export default HardestHitStore



// WEBPACK FOOTER //
// ./src/stores/hardest-hit-store.js